export const normalizeCardNumber = (value: string): string => value.replace(/\s/g, '');
